import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiCacheService } from '../cache-service/api-cache-service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private cache = inject(ApiCacheService);

  private baseURL: string = environment.HTTP;

  //#region Account Setting
  private apiGetUserByCode = `${this.baseURL}/AccountSetting/GetByUserCode`;
  private apiUpdate = `${this.baseURL}/AccountSetting/Update`;
  private apiGetCountryPhoneCodes = `${this.baseURL}/AccountSetting/GetCountryPhoneCodes`;
  private apiValidatePass = `${this.baseURL}/AccountSetting/ValidatePassword`;
  private apiThemeColor = `${this.baseURL}/Entity/GetThemeColor`;
  private apiGenerateTotpQrCode = `${this.baseURL}/AccountSetting/GenerateTotpQrCode`;
  private apiVerifyTotpSetup = `${this.baseURL}/AccountSetting/VerifyTotpSetup`;
  private apiGenerateRecoveryCodes = `${this.baseURL}/AccountSetting/GenerateRecoveryCode`;
  private apiGetRecoveryCode = `${this.baseURL}/AccountSetting/GetRecoveryCode`;
  private apiDownloadRecoveryCodes = `${this.baseURL}/AccountSetting/DownloadRecoveryCodes`;
  private apiSendRecoveryCodesEmail = `${this.baseURL}/AccountSetting/SendRecoveryCodesEmail`;

  AccountGetByCode(code: string) {
    return this.cache.get(`apiGetUserByCode=${code}`, () => this.http.get(this.apiGetUserByCode, { params: { code: code } }));
  }

  GetCountryPhoneCodes() {
    return this.cache.get(`apiGetCountryPhoneCodes`, () => this.http.get<any>(this.apiGetCountryPhoneCodes));
  }

  AccountUpdate(data: any) {
    return this.http.post(this.apiUpdate, data);
  }

  ValidatePassword(data: any) {
    return this.http.post(this.apiValidatePass, data);
  }

  GetTheme() {
    return this.http.get(this.apiThemeColor);
  }

  GenerateTOTPQrCode() {
    return this.http.post(this.apiGenerateTotpQrCode, {});
  }

  VerifyTOTPSetup(data: any) {
    return this.http.post(this.apiVerifyTotpSetup, data);
  }

  GenerateRecoveryCodes(data: any) {
    return this.http.post(this.apiGenerateRecoveryCodes, data);
  }

  GetRecoveryCode() {
    return this.http.get(this.apiGetRecoveryCode);
  }

  SendRecoveryCodesEmail(data: any) {
    return this.http.post(this.apiSendRecoveryCodesEmail, data);
  }

  DownloadRecoveryCodes() {
    return this.http.get(this.apiDownloadRecoveryCodes, { responseType: 'blob' });
  }

  //#region Customization Column
  private apiGetCustomizationColumn = `${this.baseURL}/AccountSetting/GetCustomizationColumn`;
  private apiUpdateCustomizationColumn = `${this.baseURL}/AccountSetting/UpdateCustomizationColumn`;

  getCustomizationColumn(moduleCode: string) {
    const params = new HttpParams().append('moduleCodeKey', moduleCode);
    return this.cache.get(`apiGetCustomizationColumn=${moduleCode}`, () =>
      this.http.get<any>(this.apiGetCustomizationColumn, { params: params })
    );
  }

  updateCustomizationColumn(data: any) {
    return this.http.post(this.apiUpdateCustomizationColumn, data).pipe(
      tap(() => {
        this.cache.clear();
      })
    );
  }
}
